module.exports = __webpack_public_path__ + "media/images/consultancy-cost-34d8f1e8c48408de130243c3466726da.svg";